import 'babel-polyfill'
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import _ from 'lodash';
// 注册全局filter
import './utils/filters.js';

// element ui，第三方基于vue的ui组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import compEditForm from './components/compEditForm/index.js';
import authorSign from './components/authorSign.vue';
import router from './router/router.js';
import store from './store/index.js';
import { postErrMsg } from '@/utils/helper.js';
import { getQueryString } from '@/utils/tools.js';
import apiPath from '@/service/apiPath.js';
require('@/assets/echarts.theme.macarons.js');

const echartsImport = {
    chart: [
        // 'line',
        // 'bar',
        // 'pie',
        // 'sankey',
        // 'funnel',
        // 'effectScatter',
        // 'map',
        'tree'
    ],
    component: [
        'tooltip',
        'title',
        'dataZoom',
        'legendScroll'
    ],
}
for (let key in echartsImport) {
    echartsImport[key].forEach(item => {
        require('echarts/lib/' + key + '/' + item)
    })
}


Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(compEditForm);
Vue.component('authorSign', authorSign);

Vue.config.errorHandler = async function (err, vm, info) {
    let { message, name, script, line, column, stack } = err;
    script = !_.isUndefined(script) ? script : '';
    line = !_.isUndefined(line) ? line : 0;
    column = !_.isUndefined(column) ? line : 0;
    let stackStr = message ? message : `${name}:${message}`;
    console.error(stack);
    postErrMsg(stackStr, 25, 'cmsfe');
}
if(getQueryString('access_token')) {
    // 重定向到用户中心登陆页
    window.location.href = apiPath.AUTH_LOGIN();
} else {
    new Vue({
        router: router,
        store: store,
    }).$mount('#app');
}


// WEBPACK FOOTER //
// ./src/main.js